import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import ThankYouSection from "../../components/ThankYouSection/ThankYouSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";
import CursorMaus from "../../components/CursorMaus/CursorMaus";

const ThankYouPage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Thank You | Cash Flow Summit 2026</title>
        <meta
          name="description"
          content="Thank you for registering for Cash Flow Summit 2026. Check your email for confirmation and event details."
        />
        <meta
          name="keywords"
          content="Cash Flow Summit registration confirmation, thank you"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="noindex, nofollow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <div style={{ paddingTop: '100px' }}>
        <ThankYouSection />
      </div>
      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};
export default ThankYouPage;
